import { Pipe, PipeTransform } from '@angular/core';
import { UtilitiesService } from '../../main/services/utilities/utilities.service';

@Pipe({
    name: 'travelsDataFilter'
})
export class TravelsDataFilterPipe implements PipeTransform {
    constructor(public util: UtilitiesService) {

    }
    transform(array: any[], query: string) {
        const _query = this.util.removeDiacritics(query.toLowerCase().trim());
        return array.filter( e => {
            return (this.util.removeDiacritics(e.OriginAddress.Address.toLowerCase()).indexOf(_query) !== -1 ||
                this.util.removeDiacritics(e.DestinationAddress.Address.toLowerCase()).indexOf(_query) !== -1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/travels-data-filter.pipe.ts